import { SxProps } from "@mui/material";

export const hideNoChildSX: SxProps = {
	'&:empty': {
		display: 'none',
	},
};

export const flexCentered = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center'
}

export const removeIconMarginSX:SxProps = {
	'& .MuiButton-icon':{
		ml:0,
		mr:0
	}
}